import { createFileRoute } from '@tanstack/react-router'

import DocumentationPage from '@/components/Documentation/DocumentationPage'
import { requirePermission } from '@/utils/auth'

export const Route = createFileRoute('/documentation')({
  beforeLoad: () => {
    requirePermission('documentation')
  },
  component: DocumentationPage,
})
